import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=bd0af62c&scoped=true"
import script from "./ConfirmModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmModal.vue?vue&type=style&index=0&id=bd0af62c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0af62c",
  null
  
)

export default component.exports